import { View, ViewProps } from '@shared/components/View';
import classNames from './LoadingIndicator.module.css';

export interface LoadingIndicatorProps extends ViewProps {
  size?: 'small' | 'medium' | 'large';
}

export function LoadingIndicator({
  size = 'medium',
  className,
  ...viewProps
}: LoadingIndicatorProps) {
  return (
    <View
      {...viewProps}
      className={[classNames.loadingIndicator, className]}
      data-size={size}
      role="progressbar"
    >
      <div className={classNames.spinner} />
    </View>
  );
}
